<template>
	<div class="main">
    <div class="banner">

    </div>
		<el-form ref="form" label-width="0px" label-position="left" class="login" autocomplete="off" :model="ruleForm" :rules="rules" v-if="tokenLonin==false">

		  <el-form-item prop="logname">
		    <el-input type="text" v-model="ruleForm.logname" autocomplete="off" placeholder="" class="input"></el-input>

		  </el-form-item>
		  <el-form-item prop="pass">
		    <el-input type="password" v-model="ruleForm.pass" placeholder="" autocomplete="off" ref="pass" class="input" @focus="focusPass" @blur="checkPass"></el-input>
		  </el-form-item>
		  <el-checkbox v-model="remember" class="remember input">记住密码</el-checkbox>
		  <el-form-item class="bt">
		    <el-button @click="submit" v-if="logining==false" class="inputButton">登录</el-button>
		  </el-form-item>
		</el-form>
    <div class="footer">Copyright © 2020 东营金石软件有限公司</div>
	</div>

</template>

<script>
import { mapMutations } from 'vuex';
import * as util from '@/utils/util.js';

  export default {
    data() {
      return {
        logining: false,
        remember: false,
        ruleForm: {
          logname: "",
          pass: ""
        },
        rules: {
          logname: [
            {
              required: true,
              message: "请输入用户名",
              trigger: "change"
            }
          ],
          pass: [
            {
              required: true,
              message: '请输入密码',
              trigger: 'change'
            }
          ]
        },
        redirect: '',
        isEdit: false,
        remPass: '',
        tokenLonin: false,
      }
    },
    methods: {
      ...mapMutations(['setToken','setRefreshToken','worktabInit','delToken','delRefreshToken','setUserInfo','delUserInfo']),
      submit() {
        //console.log(this.ruleForm.logname + "," + this.ruleForm.pass);
        var _this = this;
        let loading;
        _this.delUserInfo();
        this.$refs.form.validate((valid)=> {
          //console.log('submit');
					
					if(util.CheckSQL(this.ruleForm.logname) || this.ruleForm.logname.indexOf('\'')>=0){
						util.Alert('用户名存在非法字符！');
						return;
					}
          if(valid) {
            loading = this.$loading({
              lock: true,
              text: '正在登录......',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.3)'
            });
            this.logining = true;

            let pass='';
            //console.log(pass);
            if(this.remPass!=''&&this.isEdit==false){
              pass=this.remPass;
            }
            else
            {
              pass=this.$getRsaCode(this.ruleForm.pass);
            }
            //console.log(pass);


            //if(isEdit) {
            //  this.$getRsaCode(this.ruleForm.pass)
            //}
            var loginParam = {logname: this.ruleForm.logname, password: pass};

            let token="";
            let refreshToken="";
            var url="/Handler/Login.ashx";


            this.$ajax.post(url,loginParam).then((response)=>{
              //console.log(response.data);

              let value=response.data;

              let errorCode=value.errorCode;

              if(errorCode=="0")
              {
                this.$message({
                  type: 'success',
                  message: '登录成功'
                });
                token=value.token;
                refreshToken=value.refreshToken;

                if(this.remember)
                {
                  localStorage.setItem('logname',this.ruleForm.logname);
                  localStorage.setItem('pass',pass);
                  localStorage.setItem('remember','1');
                }
                else
                {
                  localStorage.removeItem('logname');
                  localStorage.removeItem('pass');
                  localStorage.removeItem('remember');

                }

                //console.log(value.userinfo,JSON.stringify(value.userinfo));

                let userinfo=JSON.stringify(value.userinfo);
                //_this.logining=false;
                _this.setUserInfo(userinfo);
                _this.setToken({token: token}); //保存Token
                _this.setRefreshToken({token: refreshToken}); //保存刷新Token
                localStorage.setItem("worktabList",''); //清空缓存的tab页标签
                this.$store.state.worktab.list=[{name: 'Main',tabname: '首页',path: '/main'}];
                _this.worktabInit();  //初始化tabs列表
                sessionStorage.setItem('user', JSON.stringify({logname: this.ruleForm.logname}));

                setTimeout(()=>{
                  this.$router.push({path: '/main'});
                  loading.close();
                },100);
              }
              else
              {
                loading.close();
                _this.logining=false;
                let desc=value.desc;
                // this.$message({
                //   type: 'error',
                //   message: '登录失败: ' + desc
                // });
                this.$alert('登录失败: ' + desc, '系统提示', {
                  confirmButtonText: '确定',
                  callback: action => {

                  }
                });
              }

            },function(err){
              //console.log(err);
              loading.close();
              _this.logining=false;

              // _this.$alert('登录失败: ' + err.statusText + '('+ err.status + ')', '系统提示', {
              //   confirmButtonText: '确定',
              //   callback: action => {

              //   }
              // });
              // _this.$message({
              //   type: 'error',
              //   message: '登录失败: ' + err.statusText + '('+ err.status + ')'
              // });
            });


            //console.log('submit2');
          } else {
            //console.log("请输入用户名密码");
          }
        });
      },
      saveObjArr(name, data) { //localStorage 存储数组对象的方法
        localStorage.setItem(name, JSON.stringify(data))
      },
      getObjArr(name) { //localStorage 获取数组对象的方法
        return JSON.parse(window.localStorage.getItem(name));
      },
      focusPass(){
        //this.isEdit=true;
        this.$refs.pass.select();
      },
      checkPass(){
        if(this.ruleForm.pass!=this.remPass)
        {
          this.isEdit=true;
        }
      },
    },
    mounted() {
      let tokenStr='G4EcY3jLphRyjwzDbSc1HYLNgSQp3vBiNjcJXzk/KvN56EUAgjiXvSJmc2CpNGKfjiCwMqoQDDWAJV5LxhemNVwOeBAUizBKv5J6DxI8xurTKqvIw8eHxwWvR7paL5eRbZCspn9dIvzXclaZov0A4bOfMNfeyQ67OyUY6/NNRWihMOBVnyWEK0YeXBkvORbpVDbE+HikIw9xmdwYBBX276MihtFtxHIEef9D1yD2depHpfrsm8NSRGy0Mttk8EQlxjP80o+LNLlfrZvA+sovIn1fqIJrKlomExBQ6RZJy89jCrfKUE1G7DTOa0PpRuqiuNX9TPXAO4dsg+/Nr7RK5BJ/fosxliqk6nYaBJpbOt4UbmcQ8/MndLQO6Zo+nffk6eimspqEH4fZZjGTil/H617kedKgzt9uCo/4UvUvrtTNqN6p2bDBJwC9sHH6wkq65MWBr2DvXFrlKnImPnXXQTd/vC2yerFPiIoNSm0uIQ4l3Z+EIVaJodDYXxbhHoDt';
      if(this.$route.query && this.$route.query.logname && this.$route.query.logname!="" && this.$route.query.token && this.$route.query.token!=""){
        this.tokenLonin=true;
        this.submit2(this.$route.query.logname,encodeURIComponent(tokenStr));
        //console.log('token login');
      }
      else
      {
        let logname=localStorage.getItem('logname');
        let pass=localStorage.getItem('pass');
        let remem=localStorage.getItem('remember');

        this.remPass=pass;

        if(remem!=null&&remem=='1')
        {
          this.remember=true;
          if(logname!=null)
          {
            this.ruleForm.logname=logname;

          }
          if(pass!=null)
          {
            this.ruleForm.pass=pass;
          }
        }

        //console.log(logname,pass,remem);

      }

      if(this.$route.query.redirect==''||this.$route.query.redirect==undefined)
      {
        this.redirect='/main';
      }
      else
      {
        this.redirect=this.$route.query.redirect;
      }

    }

  }
</script>

<style lang="scss" scoped="scoped">
	
  .main {
    height: 100%;
    width: 100%;
    background: url(../assets/login_bg.png);
    background-size: 100% 100%;
    display: inline-block;
    .banner {
      margin: 0 auto;
      margin-top: 100px;
      width: 756px;
      height: 162px;
      border: 0px solid #FFFFFF;
      background: url(../assets/log_banner.png) no-repeat 0px 10px;

    }
  }
  .login {
    width: 520px;
    margin: 50px auto;
    border: 0px solid #CCCCCC;
    border-radius: 5px;
    padding: 0px 20px;
    text-align: left;
    .title {
      font-size: 18px;
      font-weight: bold;
      text-align: center;
    }
    .remember {
      margin-bottom: 20px;
      font-size: 20px;
      color: #FFFFFF;
    }
    .bt {
      text-align: center;
    }
    .input {
      //background-color: rgba(39,64,90,0.58);
    }
  }
  .footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100px;
    line-height: 100px;
    font-size: 16px;
    color: #bfdfff;
  }
</style>
<style>
	
  .input .el-input__inner {
    background-color: rgba(39,64,90,0.58);
    border: 1px solid rgba(255,255,255,0.37);
    border-radius: 25px;
    color: #FFFFFF;
    height: 50px;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 20px;
    font-family: 'Microsoft YaHei';
  }
  .inputButton {
    width: 100%;
    height: 50px;
    border-radius: 25px;
    font-size: 24px;
    font-weight: bold;
    color: #1976d3;
    font-family: 'Microsoft YaHei';
  }
  .input .el-checkbox__label {
    font-size: 20px;
  }
  .input .el-checkbox__inner {
    background-color: rgba(39,64,90,0.58);
    zoom: 150%;
  }
  .input .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #FFFFFF;
  }
  .login .el-form-item__content .el-form-item__error {
    top: 8px !important;
    left: 20px !important;
    font-size: 20px;
}
</style>
